// extracted by mini-css-extract-plugin
export default {"faqs":"vC-z","faqContent":"wC-z","faq":"xC-z"};